import { render, staticRenderFns } from "./ConfigWebsiteCatalogueActive.vue?vue&type=template&id=82dc4178&scoped=true"
import script from "./ConfigWebsiteCatalogueActive.vue?vue&type=script&lang=js"
export * from "./ConfigWebsiteCatalogueActive.vue?vue&type=script&lang=js"
import style0 from "./ConfigWebsiteCatalogueActive.vue?vue&type=style&index=0&id=82dc4178&prod&lang=scss"
import style1 from "./ConfigWebsiteCatalogueActive.vue?vue&type=style&index=1&id=82dc4178&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82dc4178",
  null
  
)

export default component.exports